//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// auth pages
import SignupEmail from "views/AuthPages/SignupEmail";
import VerifyOTP from "views/AuthPages/VerifyOTP";
import SignupDetails from "views/AuthPages/SignupDetails";
import Login from "views/AuthPages/Login";
import ForgotPassword from "views/AuthPages/ForgotPassword";
import ResetPassword from "views/AuthPages/ResetPassword";
import CreateadminPassword from "views/AuthPages/CreateadminPassword";

import CustomerLogin from "views/AuthPages/CustomerLogin";
import LoyaltyInactive from "views/Errors/LoyaltyInactive";
import Maintanance from "views/Errors/Maintenance";
import SessionExpired from "views/Errors/SessionExpired";

import EnrollmentConsent from "views/AuthPages/OneWeb/EnrollmentConsent";
import TransferConsent from "views/AuthPages/OneWeb/TransferConsent";
import ManualEnrollmentConsent from "views/AuthPages/OneWeb/ManualEnrollmentConsent";
import ManualTransferConsent from "views/AuthPages/OneWeb/ManualTransferConsent";
import MembershipUnassigned from "views/AuthPages/OneWeb/MembershipUnassigned";
import EnrollmentAdminConsent from "views/AuthPages/OneWeb/EnrollmentAdminConsent";
import TransferAdminConsent from "views/AuthPages/OneWeb/TransferAdminConsent";
import EnrollmentAdminConsentPending from "views/AuthPages/OneWeb/EnrollmentAdminConsentPending";
import TransferAdminConsentPending from "views/AuthPages/OneWeb/TransferAdminConsentPending";
import UploadConsent from "views/AuthPages/OneWeb/UploadConsent";
import ThriveSignatureEnrollment from "views/AuthPages/OneWeb/Thrive-Signature-Enrollment/Parent";
import ThriveServicePlusEnrollment from "views/AuthPages/OneWeb/Thrive-Service-Plus-Enrollment/Parent";
import UpgradeLoyalty from "views/AuthPages/OneWeb/UpgradeLoyalty";
import GepResponse from "views/AuthPages/GepResponse";
import ThriveSignature from "views/AuthPages/OneWeb/ThriveSignature";
import ThriveServicePlus from "views/AuthPages/OneWeb/ThriveServicePlus";
import Popup from "views/AuthPages/OneWeb/popup";
import DormantView from "views/AuthPages/OneWeb/DormantView";
// import ThriveUnlockedStatus from "views/AuthPages/OneWeb/Thrive-Unlocked-Enrollment/ThriveUnlockedStatus";
import ThriveUnlocked from "views/AuthPages/OneWeb/Thrive-Unlocked-Enrollment/ThriveUnlocked";
// import ThriveUnlockedReview from "views/AuthPages/OneWeb/Thrive-Unlocked-Enrollment/ThriveUnlockedReview";
// import ThriveUnlockedStatusEligibility from "views/AuthPages/OneWeb/Thrive-Unlocked-Enrollment/ThriveUnlockedEligibility";
// import ThriveUnlockedEligibilityReview from "views/AuthPages/OneWeb/Thrive-Unlocked-Enrollment/ThriveUnlockedEligibilityReview";
// import ThriveUnlockedExist from "views/AuthPages/OneWeb/Thrive-Unlocked-Enrollment/ThriveUnlockedExist";
// import ThriveUnlockedNotEligibility from "views/AuthPages/OneWeb/Thrive-Unlocked-Enrollment/ThriveUnlockedNotEligibility";
//  import ThriveUnlockedPending from "views/AuthPages/OneWeb/Thrive-Unlocked-Enrollment/ThriveUnlockedPending";
  import ThriveSignatureCheck from "views/AuthPages/OneWeb/Thrive-Signature-Landing-Enrollment/ThriveSignature";
  //  import ThriveSignatureUpgrade from "views/AuthPages/OneWeb/Thrive-Signature-Landing-Enrollment/ThriveSignatureUpgrade";
  //  import ThriveSignatureConfirmation from "views/AuthPages/OneWeb/Thrive-Signature-Landing-Enrollment/ThriveSignatureConfirmation";
  // import ThriveSignatureEligibility from "views/AuthPages/OneWeb/Thrive-Signature-Landing-Enrollment/ThriveSignatureEligibility";
  // import ThriveSignatureNotEligible from "views/AuthPages/OneWeb/Thrive-Signature-Landing-Enrollment/ThriveSignatureNotEligible";
  // import ThriveSignatureInprogress from "views/AuthPages/OneWeb/Thrive-Signature-Landing-Enrollment/ThriveSignatureInprogress";















var authRoutes = [
  {
    path: "/enrollment-consent",
    name: "Enrollment Consent",
    component: EnrollmentConsent,
  },
  {
    path: "/transfer-consent",
    name: "Transfer Consent",
    component: TransferConsent,
  },
  {
    path: "/manual-enrollment-consent",
    name: "Manual Enrollment Consent",
    component: ManualEnrollmentConsent,
  },
  {
    path: "/manual-transfer-consent",
    name: "Manual Transfer Consent",
    component: ManualTransferConsent,
  },
  {
    path: "/membership-unassigned",
    name: "Membership Unassigned",
    component: MembershipUnassigned,
  },
  {
    path: "/enrollment-admin-consent-pending",
    name: "Enrollment Admin Consent Pending",
    component: EnrollmentAdminConsentPending,
  },
  {
    path: "/transfer-admin-consent-pending",
    name: "Transfer Admin Consent Pending",
    component: TransferAdminConsentPending,
  },
  {
    path: "/loyalty-inactive",
    name: "Loyalty Inactive",
    component: LoyaltyInactive,
  },
  {
    path: "/enrollment-admin-consent",
    name: "Enrollment Consent",
    component: EnrollmentAdminConsent,
  },
  {
    path: "/transfer-admin-consent",
    name: "Transfer Consent",
    component: TransferAdminConsent,
  },
  { path: "/employeeemail", name: "SignupEmail", component: SignupEmail },
  { path: "/verify-otp", name: "Verify OTP", component: VerifyOTP },
  { path: "/signup", name: "SignupDetails", component: SignupDetails },
  {
    path: "/forgotpassword",
    name: "ForgotPassword",
    component: ForgotPassword,
  },
  { path: "/resetpassword", name: "ResetPassword", component: ResetPassword },
  { path: "/createadminpassword", name: "CreateadminPassword", component:CreateadminPassword },
  { path: "/login", name: "Login", component: Login },
  { path: "/customerlogin", name: "customerlogin", component: CustomerLogin },
  {
    path: "/maintanance",
    name: "ServerMaintanance",
    component: Maintanance,
  },
  {
    path: "/session-expired",
    name: "SessionExpired",
    component: SessionExpired,
  },
  {
    path: "/upload-consent",
    name: "Upload Consent",
    component: UploadConsent,
  },
  {
    path: "/thrive-signature-enroll",
    name: "ThriveSignatureEnrollment",
    component: ThriveSignatureEnrollment,
  },
  {
    path: "/thrive-service-plus-enroll",
    name: "ThriveServicePlusEnrollment",
    component: ThriveServicePlusEnrollment,
  },
  // {
  //   path: "/upgrade-loyalty",
  //   name: "upgradeLoyalty",
  //   component: UpgradeLoyalty,
  // },
  {
    path: "/gep-response",
    name: "GepResponse",
    component: GepResponse,
  },
  {
    path: "/thrive-signature",
    name: "ThriveSignature",
    component: ThriveSignature,
  },

  {
    path: "/thrive-service-plus",
    name: "ThriveServicePlus",
    component: ThriveServicePlus,
  },
  {
    path: "/dormant-view",
    name: "DormantView",
    component: DormantView
  },

  // {
  //   path: "/thrive-unlocked-status",
  //   name: "ThriveUnlockedStatus",
  //   component: ThriveUnlockedStatus
  // },

  {
    path: "/thrive-unlocked",
    name: "ThriveUnlocked",
    component: ThriveUnlocked
  },

  // {
  //   path: "/thrive-unlocked-review",
  //   name: "ThriveUnlockedReview",
  //   component: ThriveUnlockedReview
  // },

  // {
  //   path: "/thrive-unlocked-eligibility-review",
  //   name: "ThriveUnlockedElgibilityReview",
  //   component: ThriveUnlockedEligibilityReview
  // },

  // {
  //   path: "/thrive-unlocked-eligibilty-status",
  //   name: "ThriveUnlockedStatusEligibility",
  //   component: ThriveUnlockedStatusEligibility
  // },

  // {
  //   path: "/thrive-unlocked-exist",
  //   name: "ThriveUnlockedExist",
  //   component: ThriveUnlockedExist
  // },

  // {
  //   path: "/thrive-unlocked-noteligibility",
  //   name: "ThriveUnlockedNotEligibility",
  //   component: ThriveUnlockedNotEligibility
  // },

  // {
  //   path: "/thrive-unlocked-pending-approval",
  //   name: "ThriveUnlockedPending",
  //   component: ThriveUnlockedPending
  // },

  {
    path: "/upgrade-loyalty",
    name: "ThriveSignatureCheck",
    component: ThriveSignatureCheck
  },

  // {
  //   path: "/thrive-signature-upgrade",
  //   name: "ThriveSignatureUpgrade",
  //   component: ThriveSignatureUpgrade
  // },

  //  {
  //   path: "/thrive-signature-confirmation",
  //   name: "ThriveSignatureConfirmation",
  //   component: ThriveSignatureConfirmation
  // },

  //  {
  //   path: "/thrive-signature-eligibility",
  //   name: "ThriveSignatureEligibility",
  //   component: ThriveSignatureEligibility
  // },

  // {
  //   path: "/thrive-signature-noteligible",
  //   name: "ThriveSignatureNotEligible",
  //   component: ThriveSignatureNotEligible
  // },

  // {
  //   path: "/thrive-signature-inprogress",
  //   name: "ThriveSignatureInprogress",
  //   component: ThriveSignatureInprogress
  // },

];

export default authRoutes;


